'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	calcLabelCenterPoint = require('@mindmup/mapjs/src/browser/calc-label-center-point'),
	findLine = require('@mindmup/mapjs/src/browser/find-line'),
	ENTER = 13,
	ESC = 27;
mmWidgets.fn.nodeLineLabelEditorWidget = function (mapEditorModel, mapModel) {
	const autosizeInput = require('autosize-input'); // needs to be here for testem execution
	return mmWidgets.each(this, function () {
		const stage = this,
			editLabel = function (line) {
				const connectorGroupElement = line && mmWidgets(findLine(line, stage.domElements[0])),
					connectorGroup = connectorGroupElement.domElements[0],
					lineProperties = mapModel.getLineProperties(line),
					centrePoint = calcLabelCenterPoint(
						lineProperties.connection,
						lineProperties.fromBox,
						lineProperties.toBox,
						lineProperties.connection.d
					),
					existingText = connectorGroup.querySelector('text.mapjs-connector-text'),
					oldLabel = lineProperties.connection.label,
					existingTextRect = existingText && existingText.getClientRects()[0],
					inputBox = mmWidgets('<input>').appendTo(stage),
					inputPlacement = {};

				if (!existingTextRect) {
					inputPlacement.width = 100;
					inputPlacement.height = 20;
				} else {
					inputPlacement.width = existingTextRect.width;
					inputPlacement.height = existingTextRect.height;
				}
				inputBox.val(oldLabel);
				inputBox.css({
					fontSize: lineProperties.connection.theme.label.text.font.sizePx + 'px',
					fontWeight: lineProperties.connection.theme.label.text.font.weight,
					position: 'absolute',
					left: Math.round(centrePoint.x - inputPlacement.width / 2) + 'px',
					top: Math.round(centrePoint.y - inputPlacement.height) + 'px',
					width: inputPlacement.width + 'px',
					minWidth: inputPlacement.width + 'px',
					height: inputPlacement.height + 'px',
					transform: connectorGroup.style.transform
				});
				inputBox.addClass('mapjs-connector-text').attr('placeholder', 'line label');
				//TODO: ensure it's visible?
				mapEditorModel.setInputEnabled(false);
				inputBox.on('blur', function () {
					const newLabel = inputBox.val().trim();
					mapEditorModel.setInputEnabled(true);
					if (newLabel !== oldLabel) {
						mapEditorModel.updateLineProperty('label', newLabel, line);
					}
					inputBox.remove();
				}).on('keyup', function (e) {
					if (e.keyCode === ENTER) {
						inputBox.blur();
					} else if (e.keyCode === ESC) {
						inputBox.val(oldLabel);
						inputBox.blur();
					}
				});
				autosizeInput(inputBox.domElements[0] /*, { minWidth: false }*/);
				inputBox.focus();
				inputBox.domElements[0].select();
			};
		mapEditorModel.addEventListener('lineLabelEditRequested', editLabel);

	});
};
